import { StubTokenDefinition } from "./stub/StubTokenDefinition";

const permissionListWithSongsheetsRead = ["songsheets:read"];

export const noCrewPayingUser = new StubTokenDefinition(
  "NoCrewPayingUser",
  permissionListWithSongsheetsRead,
);
export const nomintOnlyUserTokenDefinition = new StubTokenDefinition(
  "NomintOnlyUser",
);
export const adorayOnlyUserTokenDefinition = new StubTokenDefinition(
  "AdorayOnlyUser",
);
export const adorayLuzernOnlyUserTokenDefinition = new StubTokenDefinition(
  "AdorayLuzernOnlyUser",
);
export const payingAdorayLuzernOnlyUserTokenDefinition =
  new StubTokenDefinition(
    "PayingAdorayLuzernOnlyUser",
    permissionListWithSongsheetsRead,
  );
export const adorayBernOnlyUserTokenDefinition = new StubTokenDefinition(
  "AdorayBernOnlyUser",
);

export const payingAllOrganizationsUserTokenDefinition =
  new StubTokenDefinition(
    "PayingAllOrganizationsUser",
    permissionListWithSongsheetsRead,
  );

/** Owner of the private playlists of the Cypress tests (`cypress/util/FixturePlaylists.ts`) */
export const payingAdorayNomintSecondUserTokenDefinition =
  new StubTokenDefinition(
    "PayingAdorayNomintSecondUser",
    permissionListWithSongsheetsRead,
  );

export function permissionsFor(
  stubToken: StubTokenDefinition,
): readonly string[] {
  const fakeTokenEntry = auth0UserStub.find(
    (f) => f.tokenWithoutPrefix === stubToken.tokenWithoutPrefix,
  );
  return fakeTokenEntry ? fakeTokenEntry.content.permissions : [];
}

//keep in sync with SecurityTokenUtils on server side
export const auth0UserStub: StubTokenDefinition[] = [
  noCrewPayingUser,
  nomintOnlyUserTokenDefinition,
  adorayOnlyUserTokenDefinition,
  adorayLuzernOnlyUserTokenDefinition,
  payingAdorayLuzernOnlyUserTokenDefinition,
  adorayBernOnlyUserTokenDefinition,
  new StubTokenDefinition("WallisOnlyUser"),
  new StubTokenDefinition("AdorayNomintUser"),
  payingAllOrganizationsUserTokenDefinition,
  payingAdorayNomintSecondUserTokenDefinition,
  new StubTokenDefinition("AdorayWallisUser"),
  new StubTokenDefinition("WallisNomintUser"),
  new StubTokenDefinition("NomintAdorayWallisUser"),
];
